module.exports = __webpack_public_path__ + "img/EKI_MARCHE_tc.dd97e253.jpg";